import ServiceExec from '@/common/utils/ServiceExec';
import { moreFamily } from '@/common/service/apiList';
import store from '@/store';

export default {
  getFamilyList: async function({ commit, getters }) {
    const { representFamilyCode } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(moreFamily.getList, { familyCode: representFamilyCode });
    if (ServiceExec.status.OK !== status) return false;
    commit('setMoreFamilyList', data);
  },
  joinFamily: async function({ commit, getters }, payload) {
    const { userNo } = store.getters['user/getUserData'];
    payload.userNo = userNo;
    let searchParams = new URLSearchParams(payload);
    const { status } = await ServiceExec.post(moreFamily.joinFamily + '?' + searchParams.toString());
    return ServiceExec.status.OK === status;
  },
  deleteFamily: async function({ commit, getters }, payload) {
    const { representFamilyCode } = store.getters['user/getUserData'];
    payload.familyCode = representFamilyCode;
    const { status } = await ServiceExec.delete(moreFamily.deleteFamily + payload.familyNo, payload);
    return ServiceExec.status.OK === status;
  },
  updateFamilyName: async function({ commit, getters }, familyName) {
    const { userNo, familyCode } = store.getters['user/getUserData'];
    const payload = {
      familyCode: familyCode,
      familyName: familyName
    };
    let searchParams = new URLSearchParams(payload);
    const { status } = await ServiceExec.put(moreFamily.updateFamilyName + userNo + '?' + searchParams.toString());
    return ServiceExec.status.OK === status;
  },
  addFamily: async function({ commit, getters }) {
    const { userNo, name } = store.getters['user/getUserData'];
    const payload = {
      userNo: userNo,
      name: name
    };
    let searchParams = new URLSearchParams(payload);
    const { status } = await ServiceExec.post(moreFamily.addFamily + '?' + searchParams.toString());
    return ServiceExec.status.OK === status;
  }
};
